import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TreeNodeWithDetails } from '../../../../tree-viewer/tree-node.model';
import { OutputType } from '../../planning-output.model';
import { Pattern } from '../../../../../patterns/pattern.model';
import { TreeNodeTypeEnum } from '../../../../tree-viewer/tree-node-type.enum';
import { DetailMessageHelper } from './detail-message.helper';
import { NavigationService } from '../../../../../navbar/navigation.service';
import _ from 'lodash';

@Component({
    selector: 'adm4-detail-message',
    template: `
@switch (outputType) {
  @case (OutputType.GENERATION) {
    <span>This {{node.type | lowercase}} was generated by the pattern </span>
    @if (canDisplayPatternLink) {
      <a (click)='navigateToPattern(pattern.patternId)'>
        {{pattern.name}} <mat-icon>open_in_new</mat-icon>
      </a>
    }
    <span> for the target host <strong>{{node.output.host}}.</strong></span>
  }
  @case (OutputType.PLAN) {
    <span>
      This {{node.type | lowercase}} {{actionMessage}} on the target host <strong>{{node.output.host}}.</strong>
      <!-- This is special case for directories when it will not be changed but something within it might change -->
      @if (node.type === TreeNodeTypeEnum.Directory && !node?.details.tasks.length && node.hasDescendantTask) {
        <span>
          However, some of the files and directories within this directory will change.
        </span>
      }
    </span>
    @if (canDisplayPatternLink) {
      <span>It was generated by the pattern </span>
      <a (click)='navigateToPattern(pattern.patternId)'>
        {{pattern.name}} <mat-icon class='details-link'>open_in_new</mat-icon>
      </a>
    }
  }
}
`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DetailMessageComponent implements OnChanges {
  private navigationService = inject(NavigationService);

  @Input() node: TreeNodeWithDetails<any>;
  @Input() projectKey: string;
  @Input() pattern: Pattern;
  @Input() outputType: OutputType;
  readonly OutputType = OutputType;
  readonly TreeNodeTypeEnum = TreeNodeTypeEnum;
  actionMessage: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['node'] && this.node) {
      this.actionMessage = DetailMessageHelper.getActionTextByCriteria(this.node, this.outputType);
    }
  }

  navigateToPattern(patternId: string): void {
    this.navigationService.navigateToPattern(this.projectKey, patternId);
  }

  get canDisplayPatternLink(): boolean {
    return !_.isNil(this.projectKey) && !_.isNil(this.pattern);
  }
}
